import "jquery-ui/ui/widgets/slider";

$(function () {
  // Показать/скрыть фильтры
  $("#js-category-filter-btn").on("click", function () {
    const desktop = window.matchMedia("(min-width: 992px)").matches;
    $(this).toggleClass("show");

    if ($(this).hasClass("show")) {
      $(this)
        .find(".df-category__settings__block__icon")
        .addClass(desktop ? "df-rotate--n90" : "df-rotate--180");
      $(this).find(".df-category__settings__block__text").text($(this).data('hide-text'));

      $("#js-category-products")
        .removeClass("col-lg-12")
        .addClass("col-lg-9 active");
      $("#js-category-filter").removeClass("d-none").addClass("col-lg-3");
    } else {
      $(this)
        .find(".df-category__settings__block__icon")
        .removeClass("df-rotate--180")
        .removeClass("df-rotate--n90");
      $(this)
        .find(".df-category__settings__block__text")
        .text($(this).data('show-text'));

      $("#js-category-products")
        .removeClass("col-lg-9 active")
        .addClass("col-lg-12");
      $("#js-category-filter").removeClass("col-lg-3").addClass("d-none");
    }
  });

  // Сброс фильтров
  $('#js-category-filter-form').on('reset', function(e) {
    e.stopPropagation();
    window.location.href = window.location.pathname;
  });

  // Слайдеры в фильтрах
  const rangeSliders = $(".js-input-range");
  rangeSliders.each(function () {
    const minValue =
      Number($(this).next().find(".js-input-range-min").data("min")) || 0;
    const maxValue =
      Number($(this).next().find(".js-input-range-max").data("max")) || 0;

    $(this).slider({
      min: minValue,
      max: maxValue,
      values: [
        $(this).next().find(".js-input-range-min").val(),
        $(this).next().find(".js-input-range-max").val(),
      ],
      range: true,
      animate: "fast",
      slide: function (event, ui) {
        $(this).next().find(".js-input-range-min").val(ui.values[0]);
        $(this).next().find(".js-input-range-max").val(ui.values[1]);
      },
    });

    $(this)
      .next()
      .find("input")
      .on("change", function () {
        const min = $(this)
          .parent()
          .prev(".js-input-range")
          .slider("option", "min");
        const valueMin = $(this)
          .parent()
          .prev(".js-input-range")
          .slider("values", 0);

        const max = $(this)
          .parent()
          .prev(".js-input-range")
          .slider("option", "max");
        const valueMax = $(this)
          .parent()
          .prev(".js-input-range")
          .slider("values", 1);

        let inputValue = $(this)
          .val()
          .replace(/[^\d.]/g, "");

        if (!inputValue) {
          inputValue = 0;
        }

        if ($(this).data("min") !== undefined && inputValue !== valueMin) {
          inputValue =
            inputValue < min
              ? min
              : inputValue > valueMax
              ? valueMax
              : inputValue;
          $(this)
            .parent()
            .prev(".js-input-range")
            .slider("values", 0, inputValue);
        }

        if ($(this).data("max") !== undefined && inputValue !== valueMax) {
          inputValue =
            inputValue > max
              ? max
              : inputValue < valueMin
              ? valueMin
              : inputValue;
          $(this)
            .parent()
            .prev(".js-input-range")
            .slider("values", 1, inputValue);
        }

        $(this).val(inputValue);
      });
  });

  // Поиск
  $("#js-category-search").on("keyup", function () {
    let searchStr = $(this).val().toLowerCase();
    let searchValues = searchStr.split(" ").filter((elem) => elem !== "");
    if (searchValues && searchValues.length > 0) {
      $("#js-category-products .js-category-products__item").filter(
        function () {
          $(this).toggle(
            searchValues.filter(
              (value) => $(this).text().toLowerCase().indexOf(value) > -1
            ).length === searchValues.length
          );
        }
      );
    } else {
      $("#js-category-products .js-category-products__item").filter(
        function () {
          $(this).toggle(true);
        }
      );
    }
    // Показ текста "товары не найдены" в случае если нет товаров удовлетворяющих условиям поиска
    let visibleProducts = $(
      "#js-category-products .js-category-products__item"
    ).not(":hidden").length;
    if (visibleProducts === 0) {
      $("#js-category-empty").removeClass("d-none");
    } else {
      $("#js-category-empty").addClass("d-none");
    }
  });

  // Сортировка
  $("#js-category-sort").on("change", function () {
    const url = $(this).val();
    window.location.replace(url);
  });

  // Варианты товаров
  $(".df-category__products__item__varieties__color").on("click", function () {
    const id = $(this).data("product-id");
    if (!$(this).hasClass("active")) {
      $(this).parents(".df-category__products__item").addClass("d-none");
      $(this)
        .parents(".df-category__products__item")
        .siblings("[data-product-id='" + id + "']")
        .removeClass("d-none");
    }
  });

  $(".df-category__products__item__varieties__radio").on("click", function (e) {
    e.preventDefault();
    const id = Number($(this).find('input').val());
    const parentId = Number($(this).parents(".df-category__products__item").data("product-id"));
    if (parentId !== id) {
      $(this).parents(".df-category__products__item").addClass("d-none");
      $(this)
        .parents(".df-category__products__item")
        .siblings("[data-product-id='" + id + "']")
        .removeClass("d-none");
    }
  });
});
